module.exports = __webpack_public_path__ + "img/nodata.0600c3f0.png";